import bannerImage from "../assets/images/login_bg_image.png";

export const BANNER_IMAGE = bannerImage;
export const LOGO_ICON = require("../assets/images/logo/nserix-primary.svg").default;
export const LOGO_ICON_DARK = require("../assets/images/logo/nserix-dark.svg").default;
export const LOGO_MARK = require("../assets/images/logo/nserix-icon.svg").default;
export const ICON_PATH = "https://d32mj6jazbc1fz.cloudfront.net/assets/icons/";
export const VIEW_SITE_URL = process.env.REACT_APP_CLIENT_APP_URL;
export const DEFAULT_PROFILE_IMAGE = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export const LOGINVALUE = {
    FORGOT_PASSWORD: "forgot-password",
    FORGOT_USERNAME: "forgot-usernmae",
    FORGOT_USERNAME_PATH: "/forgot-username",
    SUPERADMIN_FORGOT_USERNAME_PATH: "/superadmin/forgot-username",
    FORGOT_PASSWORD_PATH: "/forgot-password",
    SUPERADMIN_FORGOT_PASSWORD_PATH: "/superadmin/forgot-password",
    MESSAGES: {
        WELCOME_MESSAGE: "Welcome!",
        LOGINFORM: "Sign in to continue to Nserix",
        FOROTPASSWORD: "Enter email to reset your password",
        FORGOTUSERNAME: "Enter email to know your username",
        RESETPASSWORD: "Reset your password",
        PASSWORD_CONFIRMATION: "Please confirm your password!",
        NEW_PASSWORD_CONDITIONS: "Must include 1 digit, 1 alphabet, 1 special character, and be at least 8 characters long"
    },
};

export const THEMEVALUE = {
    DARK_THEME: "dark-theme",
    LIGHT_THEME: "light-theme",
};



// Rows in the superadmin `network_types` table. Plan and feature screens filter
// by these, and a value with no matching row silently returns an empty list --
// which reads in the UI as "there are no plans" rather than as an error.
//
// The ids were once 3 (open) and 4 (dynamic network). This deployment seeds
// only two rows, so those literals returned nothing wherever they survived:
// the Open Network plan list, the Dynamic Network plan list, the plan step of
// the add/edit-user wizard and the create-network wizard each broke separately
// as a stale number was found in one more file. Import these instead of
// writing the number.
export const NETWORK_TYPE = {
  OPEN: 1,
  DYNAMIC: 2,
} as const;
